import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { isDiscordSnowflake } from "~/lib/security";

export const Route = createFileRoute("/callback/discord")({
	component: RedirectComponent,
});

function RedirectComponent() {
	useEffect(() => {
		const guildId = new URLSearchParams(window.location.search).get("guild_id");
		const target =
			guildId && isDiscordSnowflake(guildId)
				? `/dashboard/${guildId}`
				: "/dashboard";

		window.location.replace(target);
	}, []);

	return (
		<div className="flex min-h-[calc(100vh-4rem)] flex-col items-center justify-center gap-4">
			<div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
			<p className="text-sm text-muted-foreground">
				Redirecting to your server...
			</p>
		</div>
	);
}
